import { Component, OnChanges, Input } from '@angular/core';
import { MyTaskJobStatus, MyTaskType, SalesOrder, GenTaskData, GenTaskHeadRow, GenTaskHeadCell, GenTaskDataRow, TaskCellType, GenTaskDataCell, configDefs, SubSalesOrder, UserType, SSOStatus } from '../../shared/misc-classes';
import { DataService } from '../../shared/dataservice.service';
import { GenService } from '../../shared/gen-ser.service';

@Component({
  selector: 'my-task-list',
  templateUrl: './my-task-list.component.html',
  styleUrls: ['./my-task-list.component.css']
})
export class MyTaskListComponent implements OnChanges {

  @Input() jobType: MyTaskType;
  @Input() Search : string = '';
  // @Input() jobStatusType:MyTaskJobStatus;

  @Input() salesOrders: Array<SalesOrder>;
  @Input() tableData:any;

  upcomingSelId:number = 7;

  delayedJobs: Array<GenTaskData> = [];
  //delayedJobCounter:number = 0;
  runningJobs: Array<GenTaskData> = [];
  //runningJobCounter:number = 0;
  upcomingJobs: Array<GenTaskData> = [];
  //upcomingJobCounter:number = 0;

  counters:any = {delayedJobCounter:0,runningJobCounter:0,upcomingJobCounter:0}

  sampleData: Array<GenTaskData>;

  isLoading: boolean = false;

  currDate: Date = new Date();

  userTaskType:number = MyTaskType.UNKNOWN;

  _taskList: Array<taskDef> = [
    new taskDef("001", "SO Release Date"),
    new taskDef("002", "Order Handing Over Date"),
    new taskDef("003", "SLD Submission Date"),
    new taskDef("004", "GAF Submission Date"),
    new taskDef("005", "Schematic & BOM Submission Date"),
    new taskDef("006", "GTP,CT,PT Busbar Sizing Calculation Submission Date"),
    new taskDef("007", "Drawing Approval"),
    new taskDef("008", "CT Finalization Given By PM-SCM"),
    new taskDef("009", "Special Material Finalization Given By PM-SCM"),
    new taskDef("010", "CT Finalization From SCM"),
    new taskDef("011", "Special Material Price Finalization From SCM"),
    new taskDef("012", "CT Finalization Engg to PM"),
    new taskDef("013", "Special Material Price Finalization Engg to PM"),
    new taskDef("014", "Engineering Long Lead Release"),
    new taskDef("015", "Engineering C40"),
    new taskDef("016", "Engineering C50"),
    new taskDef("017", "Engineering C60"),
    new taskDef("018", "Imported Breaker PO Release"),
    new taskDef("019", "Imported VSC PO Release"),
    new taskDef("020", "Special Relay PO Release"),
    new taskDef("021", "CT/PT PO Release"),
    new taskDef("022", "Relay PO Release"),
    new taskDef("023", "Breaker PO Release"),
    new taskDef("024", "SA PO Release"),
    new taskDef("025", "Metering PO Release"),
    new taskDef("026", "PickList Issue to Stores Requested"),
    new taskDef("027", "Imported Breaker Requested"),
    new taskDef("028", "Imported VSC Requested"),
    new taskDef("029", "Special Relay Requested"),
    new taskDef("030", "CT/PT Requested"),
    new taskDef("031", "Relay Requested"),
    new taskDef("032", "Breaker Requested"),
    new taskDef("033", "Jumper Requested"),
    new taskDef("034", "Metering Box Requested"),
    new taskDef("035", "SA Requested"),
    new taskDef("036", "Broughtout Fabrication Requested"),
    new taskDef("037", "InHouse Fabrication Requested"),
    new taskDef("038", "Material Issue to Line "),
    new taskDef("039", "Material Issue to Dispatch"),
    new taskDef("040", "Mechanical Sticker"),
    new taskDef("041", "Mechanical/Electrical Testing"),
    new taskDef("042", "FAT Requested Date"),
    new taskDef("043", "Green Sticker Requested Date"),
    new taskDef("044", "Dispatch Requested Date")
  ]

  _requestedTaskIdList:Array<string> = ["026","027","028","029","030","031","032","033","034","035","036","037"];

  constructor(private _dataService: DataService) { }

  ngOnChanges() {
    this.userTaskType = this._dataService.userMyTaskType; 
    if(this.tableData){
      this.tableData.delayedJobs = this.delayedJobs;
      this.tableData.runningJobs = this.runningJobs;
      this.tableData.upcomingJobs = this.upcomingJobs;
      this.tableData.counters = this.counters;
    }
    if (this.salesOrders) {
      //this.formatTaskData();
      this.extractAllData();
    }
  }
  
  createListItem(taskIndex:number){
    let jobStatusList:Array<MyTaskJobStatus> = [MyTaskJobStatus.DELAYED,MyTaskJobStatus.RUNNING,MyTaskJobStatus.UPCOMING];
    for(var i=0;i<jobStatusList.length;i++){
        this.getGenTaskObj(jobStatusList[i], this._taskList[taskIndex].taskId, this._taskList[taskIndex].taskName);
    }
  }

  extractAllData() {
    // console.log(this.upcomingSelId);
    this.isLoading = true;
    this.delayedJobs.length = 0;
    this.counters.delayedJobCounter = 0;
    this.runningJobs.length = 0;
    this.counters.runningJobCounter = 0;
    this.upcomingJobs.length = 0;
    this.counters.upcomingJobCounter = 0;
    let _startTime: Date = new Date();

    this.salesOrders.forEach((_tmpSalesOrder: SalesOrder) => {
      //if(_tmpSalesOrder.marketingIP.salesOrderNo == '75')
        this.extractSaleOrder(_tmpSalesOrder);
    });

    this.delayedJobs.forEach((_dJob:GenTaskData) => {
      this.counters.delayedJobCounter += _dJob.taskDisplayDataRows.length;
    });

    this.runningJobs.forEach((_rJob:GenTaskData) => {
      this.counters.runningJobCounter += _rJob.taskDisplayDataRows.length;
    });

    this.upcomingJobs.forEach((_uJob:GenTaskData) => {
      this.counters.upcomingJobCounter += _uJob.taskDisplayDataRows.length;
    });

    this.isLoading = false;
    
  }

  extractSaleOrder(_saleOrdr: SalesOrder) {
    if (this.jobType == MyTaskType.MARKETING) {
      this.extractSORelease(_saleOrdr);
      this.extractPlannedOrderHandingOverDate(_saleOrdr);
    }


    _saleOrdr.subSalesOrder.forEach((_subOrder: SubSalesOrder) => {

      // if(_subOrder.subOrderStatus == SSOStatus.Dispatched) {
        if (_subOrder.isSSOStatusSet(SSOStatus.Dispatched) == true) {
        return;
      }
      

      if (this.jobType == MyTaskType.PROJECT_MANAGEMENT) {
        this.extractPlannedSLDSubmissionDate(_saleOrdr, _subOrder);
        this.extractPlannedGAFSubmissionDate(_saleOrdr, _subOrder);
        this.extractPlannedSchDrwBOMSubmissionDate(_saleOrdr, _subOrder);
        this.extractPlannedGTPCTPTSubmissionDate(_saleOrdr, _subOrder);
        this.extractPlannedDrawingApprovalDate(_saleOrdr, _subOrder);
        this.extractCTFinalizationByPMtoSCMPlannedDate(_saleOrdr, _subOrder);
        this.extractSpecialMatFinalizationByPMtoSCMPlannedDate(_saleOrdr, _subOrder);  //check the conditoin later

      }
      else if (this.jobType == MyTaskType.SCM) {
        this.extractSCMFinalizationFrmSCMPlannedDate(_saleOrdr, _subOrder);
        this.extractSplMatFinalizationFrmSCMPlannedDate(_saleOrdr, _subOrder);
      }
      else if (this.jobType == MyTaskType.ENGINEERING) {
        this.extractSplMatFinalizationGivenByEnggToPMPlannedDate(_saleOrdr, _subOrder);
        this.extractCTFinalizationgiuvenbyENggTPMlannedDate(_saleOrdr, _subOrder);
        this.extractEnggLongLeadRelasePlannedDate(_saleOrdr, _subOrder);
        //this.extractPlannedGTPCTPTSubmissionDate(_saleOrdr, _subOrder);
        this.extractEnggPlannedC40(_saleOrdr, _subOrder);
        this.extractEnggPlannedC50(_saleOrdr, _subOrder);
        this.extractEnggPlannedC60(_saleOrdr, _subOrder);
      }
      else if (this.jobType == MyTaskType.PURCHASE_PO) {
        if(_subOrder.pmTechSubSalesOrder.breakerApplicability_Enable == true)
          this.extractPurchasePOImportBreakerPOReleasePlannedDate(_saleOrdr, _subOrder);
        if(_subOrder.pmTechSubSalesOrder.vscApplicability_Enable == true)
          this.extractPurchasePOImportVSCPOReleasePlannedDate(_saleOrdr, _subOrder);
        if(_subOrder.pmTechSubSalesOrder.geRelayApplicability_Enable == true)
          this.extractPurchasePOGERelayPOReleasePlannedDate(_saleOrdr, _subOrder);
        this.extractPurchasePOCTPTPOReleasePlannedDate(_saleOrdr, _subOrder);
        this.extractPurchasePORelayPOReleasePlannedDate(_saleOrdr, _subOrder);
        this.extractPurchasePOBreakerPOReleasePlannedDate(_saleOrdr, _subOrder);
        this.extractPurchasePOSAPOReleasePlannedDate(_saleOrdr, _subOrder);
        this.extractPurchasePOMeteringBoxPOReleasePlannedDate(_saleOrdr, _subOrder);
      }
      else if (this.jobType == MyTaskType.MATERIAL_RECEIPT) {
        if(_subOrder.pmTechSubSalesOrder.breakerApplicability_Enable == true)
          this.extractPurchaseMatRcptImpBreakerRequestedDate(_saleOrdr, _subOrder);

        if(_subOrder.pmTechSubSalesOrder.vscApplicability_Enable == true)
          this.extractPurchaseMatRcptImpVSCRequestedDate(_saleOrdr, _subOrder);

        if(_subOrder.pmTechSubSalesOrder.geRelayApplicability_Enable == true)
          this.extractPurchaseMatRcptGERelayRequestedDate(_saleOrdr, _subOrder);
        
        this.extractPurchaseMaCTPTRequestedDate(_saleOrdr, _subOrder);
        this.extractPurchaseMaRelayRequestedDate(_saleOrdr, _subOrder);
        this.extractPurchaseMaBreakerRequestedDate(_saleOrdr, _subOrder);

        if(_subOrder.planningIP.manufacturingStrategyInhouse_Enable == true)
          this.extractPurchaseMaJumperRequestedDate(_saleOrdr, _subOrder);

        if(_subOrder.planningIP.manufacturingStrategyInhouse_Enable == true)
          this.extractPurchaseMaMeterBoxRequestedDate(_saleOrdr, _subOrder);

        this.extractPurchaseMatSARequestedDate(_saleOrdr, _subOrder);

        if(_subOrder.planningIP.manufacturingStrategyInhouse_Enable == true)
          this.extractPurchaseMatBoughtoutFabRequestedDate(_saleOrdr, _subOrder);
          
        if(_subOrder.planningIP.manufacturingStrategyInhouse_Enable == true)
          this.extractPurchaseMatInHouseFabRequestedDate(_saleOrdr, _subOrder);
      }
      else if (this.jobType == MyTaskType.PLANNING) {
        if(_subOrder.planningIP.manufacturingStrategyInhouse_Enable == true)
          this.extractPlanningPickListIssueToStoresRequestedDate(_saleOrdr, _subOrder);
      }
      else if (this.jobType == MyTaskType.STORES) {
        if(_subOrder.planningIP.manufacturingStrategyInhouse_Enable == true)
          this.extractStoresMatIssuetoLinePlannedDate(_saleOrdr, _subOrder);
        this.extractStoresMatIssuetoDispatchPlannedDate(_saleOrdr, _subOrder);
      }
      else if (this.jobType == MyTaskType.PRODUCTION) {
        this.extractProductionMechStickerPlannedDate(_saleOrdr, _subOrder);
      }
      else if (this.jobType == MyTaskType.TESTING) {
        this.extractQualityMechElectTestingRequestedDate(_saleOrdr, _subOrder);
        this.extractQualityFATRequestedDate(_saleOrdr, _subOrder);
        this.extractQualityGreenStickerRequestedDate(_saleOrdr, _subOrder);
      }
      else if (this.jobType == MyTaskType.LOGISTICS) {
        this.extractLogisticDispatchRequestedDate(_saleOrdr, _subOrder);
      }
      else if (this.jobType == MyTaskType.PLANNING_PRODUCTION) {
        this.extractProductionMechStickerPlannedDate(_saleOrdr, _subOrder);
        if(_subOrder.planningIP.manufacturingStrategyInhouse_Enable == true){
          this.extractPlanningPickListIssueToStoresRequestedDate(_saleOrdr, _subOrder);
        }
      }
    });
  }

  
  extractSORelease(_saleOrdr: SalesOrder) {
    let _tskIndx:number = 0;
    this.createListItem(_tskIndx);
    if (_saleOrdr.marketingIP.soReleaseDateActual) return;

    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType ==  MyTaskType.HEAD_MARKETING
      || this.userTaskType ==  MyTaskType.FINANCE
      || this.userTaskType ==  MyTaskType.HEAD_FINANCE){
        //admin or hod, nothing to do now.
      }
    else{
        //filter user, OK
        let mktEngEmail: string = this._dataService.getMarketingEngineerEmail(_saleOrdr.marketingIP.marketingEngineerId);
        if (mktEngEmail == null || mktEngEmail == '' || (mktEngEmail != this._dataService.userId)) {
          return;
        }
    }

    let _refDate: Date = _saleOrdr.marketingIP.soReleaseDatePlanned;
    if (_refDate) {
      // let _taskId: string = "001";
      // let _taskName: string = "SO Release Date";
      this.processThisTask(this._taskList[_tskIndx].taskId, this._taskList[_tskIndx].taskName, _refDate, _saleOrdr, null);
    }
  }
  extractPlannedOrderHandingOverDate(_saleOrdr: SalesOrder) {
    let _tskIndx:number = 1;
    this.createListItem(_tskIndx);
    if (_saleOrdr.marketingIP.actualHandingOverDate) return;
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType ==  MyTaskType.HEAD_MARKETING
      || this.userTaskType ==  MyTaskType.FINANCE
      || this.userTaskType ==  MyTaskType.HEAD_FINANCE){
        //admin or hod, nothing to do now.
    }
    else {
      //filter user, query pending
      let mktEngEmail: string = this._dataService.getMarketingEngineerEmail(_saleOrdr.marketingIP.marketingEngineerId);
      if (mktEngEmail == null || mktEngEmail == '' || (mktEngEmail != this._dataService.userId)) {
        return;
      }
    }
    let _refDate: Date = _saleOrdr.marketingIP.plannedOverHandingDate;
    if (_refDate) {
      // let _taskId: string = "002";
      // let _taskName: string = "Order Handing Over Date";
      this.processThisTask(this._taskList[_tskIndx].taskId, this._taskList[_tskIndx].taskName, _refDate, _saleOrdr, null);
    }
  }
  extractPlannedSLDSubmissionDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 2;
    this.createListItem(_tskIndx);
    if (_subSalesOrder.enggDrawIP.initialSLDSubmissionDateActual) return;

    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType ==  MyTaskType.HEAD_MARKETING
      || this.userTaskType ==  MyTaskType.FINANCE
      || this.userTaskType ==  MyTaskType.HEAD_FINANCE
      || this.userTaskType ==  MyTaskType.HEAD_PROJECT_MANAGEMENT){
        //admin or hod, nothing to do now.
    }
    else {
      //filter user
      let projEnggEmail: string = this._dataService.getProjectEngineerEmail(_saleOrdr.pmCommercial.projectEngineerId);
      let elecEnggEmail: string = this._dataService.getElecDesignEngineerEmailId(_subSalesOrder.enggDrawIP.electricalDesignEngineerId);

      if((projEnggEmail == null || projEnggEmail == '' || (projEnggEmail != this._dataService.userId))
          &&
        (elecEnggEmail == null || elecEnggEmail == '' || (elecEnggEmail != this._dataService.userId)))
       {
        return;
      }
    }
    let _refDate: Date = _subSalesOrder.pmTechSubSalesOrder.plannedSldSubmissionDate;
    if (_refDate) {
      //let _taskId: string = "003";
      //let _taskName: string = "SLD Submission Date";
      this.processThisTask(this._taskList[_tskIndx].taskId, this._taskList[_tskIndx].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractPlannedGAFSubmissionDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 3;
    this.createListItem(_tskIndx);
    if (_subSalesOrder.enggDrawIP.initialGAFDSubmissionDateActual) return;

    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType ==  MyTaskType.HEAD_MARKETING
      || this.userTaskType ==  MyTaskType.FINANCE
      || this.userTaskType ==  MyTaskType.HEAD_FINANCE
      || this.userTaskType ==  MyTaskType.HEAD_PROJECT_MANAGEMENT){
        //admin or hod, nothing to do now.
    }
    else {
      //filter user
      let projEnggEmail: string = this._dataService.getProjectEngineerEmail(_saleOrdr.pmCommercial.projectEngineerId);
      let mechEnggEmail: string = this._dataService.getMechDesignEngineerEmail(_subSalesOrder.enggDrawIP.mechanicalDesignEngineerId);

      if((projEnggEmail == null || projEnggEmail == '' || (projEnggEmail != this._dataService.userId))
          &&
        (mechEnggEmail == null || mechEnggEmail == '' || (mechEnggEmail != this._dataService.userId)))
       {
        return;
      }
    }
    let _refDate: Date = _subSalesOrder.pmTechSubSalesOrder.plannedGaDrawingSubmissionDate;
    if (_refDate) {
      // let _taskId: string = "004";
      // let _taskName: string = "GAF Submission Date";
      this.processThisTask(this._taskList[_tskIndx].taskId, this._taskList[_tskIndx].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractPlannedSchDrwBOMSubmissionDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 4;
    this.createListItem(_tskIndx);
    if (_subSalesOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual) return;

    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType ==  MyTaskType.HEAD_MARKETING
      || this.userTaskType ==  MyTaskType.FINANCE
      || this.userTaskType ==  MyTaskType.HEAD_FINANCE
      || this.userTaskType ==  MyTaskType.HEAD_PROJECT_MANAGEMENT){
        //admin or hod, nothing to do now.
    }
    else {
      //filter user
      let projEnggEmail: string = this._dataService.getProjectEngineerEmail(_saleOrdr.pmCommercial.projectEngineerId);
      let elecEnggEmail: string = this._dataService.getElecDesignEngineerEmailId(_subSalesOrder.enggDrawIP.electricalDesignEngineerId);

      if((projEnggEmail == null || projEnggEmail == '' || (projEnggEmail != this._dataService.userId))
          &&
        (elecEnggEmail == null || elecEnggEmail == '' || (elecEnggEmail != this._dataService.userId)))
       {
        return;
      }
    }
    let _refDate: Date = _subSalesOrder.pmTechSubSalesOrder.plannedSchematicDrawingDate;
    if (_refDate) {
      // let _taskId: string = "005";
      // let _taskName: string = "Schematic & BOM Submission Date";
      this.processThisTask(this._taskList[_tskIndx].taskId, this._taskList[_tskIndx].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractPlannedGTPCTPTSubmissionDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 5;
    this.createListItem(_tskIndx);
    if (_subSalesOrder.enggDrawIP.initialGTPCTPTBBSizingCalcSubmissionDateActual) return;

    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType ==  MyTaskType.HEAD_MARKETING
      || this.userTaskType ==  MyTaskType.FINANCE
      || this.userTaskType ==  MyTaskType.HEAD_FINANCE
      || this.userTaskType ==  MyTaskType.HEAD_PROJECT_MANAGEMENT){
        //admin or hod, nothing to do now.
    }
    else {
      //filter user
      let projEnggEmail: string = this._dataService.getProjectEngineerEmail(_saleOrdr.pmCommercial.projectEngineerId);
      let elecEnggEmail: string = this._dataService.getElecDesignEngineerEmailId(_subSalesOrder.enggDrawIP.electricalDesignEngineerId);

      if((projEnggEmail == null || projEnggEmail == '' || (projEnggEmail != this._dataService.userId))
          &&
        (elecEnggEmail == null || elecEnggEmail == '' || (elecEnggEmail != this._dataService.userId)))
       {
        return;
      }
    }
    let _refDate: Date = _subSalesOrder.pmTechSubSalesOrder.plannedSizingCalSubmissionDate;
    if (_refDate) {
      // let _taskId: string = "006";
      // let _taskName: string = "GTP,CT,PT Busbar Sizing Calculation Submission Date";
      this.processThisTask(this._taskList[_tskIndx].taskId, this._taskList[_tskIndx].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractPlannedDrawingApprovalDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 6;
    this.createListItem(_tskIndx);
    if (_subSalesOrder.pmTechSubSalesOrder.actualDrawingApprovalDate) return;

    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType ==  MyTaskType.HEAD_MARKETING
      || this.userTaskType ==  MyTaskType.FINANCE
      || this.userTaskType ==  MyTaskType.HEAD_FINANCE
      || this.userTaskType ==  MyTaskType.HEAD_PROJECT_MANAGEMENT){
        //admin or hod, nothing to do now.
    }
    else {
      //filter user
      let projEnggEmail: string = this._dataService.getProjectEngineerEmail(_saleOrdr.pmCommercial.projectEngineerId);

      if(projEnggEmail == null || projEnggEmail == '' || (projEnggEmail != this._dataService.userId))
       {
        return;
      }
    }
    let _refDate: Date = _subSalesOrder.pmTechSubSalesOrder.plannedDrawingApprovalDate;
    if (_refDate) {
      // let _taskId: string = "007";
      // let _taskName: string = "Drawing Approval";
      this.processThisTask(this._taskList[6].taskId, this._taskList[6].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractCTFinalizationByPMtoSCMPlannedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 7;
    this.createListItem(_tskIndx);
    if(!_subSalesOrder.enggDrawIP.ctFinalizationGivenByEnggToPMActualDate) return
    if (_subSalesOrder.pmTechSubSalesOrder.actualCtFinalizationDate) return;

    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType ==  MyTaskType.HEAD_MARKETING
      || this.userTaskType ==  MyTaskType.FINANCE
      || this.userTaskType ==  MyTaskType.HEAD_FINANCE
      || this.userTaskType ==  MyTaskType.HEAD_PROJECT_MANAGEMENT){
        //admin or hod, nothing to do now.
    }
    else {
      //filter user
      let projEnggEmail: string = this._dataService.getProjectEngineerEmail(_saleOrdr.pmCommercial.projectEngineerId);

      if(projEnggEmail == null || projEnggEmail == '' || (projEnggEmail != this._dataService.userId))
       {
        return;
      }
    }
    let _refDate: Date = _subSalesOrder.pmTechSubSalesOrder.plannedCtFinalizationDate;
    if (_refDate) {
      // let _taskId: string = "008";
      // let _taskName: string = "CT Finalization Given By PM-SCM";
      this.processThisTask(this._taskList[7].taskId, this._taskList[7].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractSpecialMatFinalizationByPMtoSCMPlannedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 8;
    this.createListItem(_tskIndx);
    if (!_subSalesOrder.enggDrawIP.isSplMatPapplicable) return;

    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType ==  MyTaskType.HEAD_MARKETING
      || this.userTaskType ==  MyTaskType.FINANCE
      || this.userTaskType ==  MyTaskType.HEAD_FINANCE
      || this.userTaskType ==  MyTaskType.HEAD_PROJECT_MANAGEMENT){
        //admin or hod, nothing to do now.
    }
    else {
      //filter user
      let projEnggEmail: string = this._dataService.getProjectEngineerEmail(_saleOrdr.pmCommercial.projectEngineerId);

      if(projEnggEmail == null || projEnggEmail == '' || (projEnggEmail != this._dataService.userId))
       {
        return;
      }
    }
    if (_subSalesOrder.pmTechSubSalesOrder.splMatFinalizationActualDate) return;
    let _refDate: Date = _subSalesOrder.pmTechSubSalesOrder.splMatPriceFinalizationPlannedDate;
    if (_refDate) {
      // let _taskId: string = "009";
      // let _taskName: string = "Special Material Finalization Given By PM-SCM";
      this.processThisTask(this._taskList[8].taskId, this._taskList[8].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractSCMFinalizationFrmSCMPlannedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 9;
    this.createListItem(_tskIndx);
    if (_subSalesOrder.scmIP.ctFinalizationFromSCMActualDate) return;
    // New
    // if (!this._dataService.isAdmin) {
    //   //filter user group
    //   if(this._dataService.userType != UserType.SCM){
    //     return;
    //   }
    // }
    // New end
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType ==  MyTaskType.SCM
      || this.userTaskType ==  MyTaskType.HEAD_SCM){
        //admin or hod, nothing to do now.
    }
    else{
      return
    }
    let _refDate: Date = _subSalesOrder.scmIP.ctFinalizationFromSCMPlannedDate;
    if (_refDate) {
      // let _taskId: string = "010";
      // let _taskName: string = "CT Finalization From SCM";
      this.processThisTask(this._taskList[9].taskId, this._taskList[9].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractSplMatFinalizationFrmSCMPlannedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 10;
    this.createListItem(_tskIndx);
    if (!_subSalesOrder.enggDrawIP.isSplMatPapplicable) return;
    // New
    // if (!this._dataService.isAdmin) {
    //   //filter user group
    //   if(this._dataService.userType != UserType.SCM){
    //     return;
    //   }
    // }
    // New end
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType ==  MyTaskType.SCM
      || this.userTaskType ==  MyTaskType.HEAD_SCM){
        //admin or hod, nothing to do now.
    }
    else{
      return
    }
    if (_subSalesOrder.scmIP.splMatFGivenbySCMtoEnggActualDate) return;
    let _refDate: Date = _subSalesOrder.scmIP.splMatFGivenbySCMtoEnggPlannedDate;
    if (_refDate) {
      // let _taskId: string = "011";
      // let _taskName: string = "Special Material Price Finalization From SCM";
      this.processThisTask(this._taskList[10].taskId, this._taskList[10].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractCTFinalizationgiuvenbyENggTPMlannedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 11;
    this.createListItem(_tskIndx);
    if (_subSalesOrder.enggDrawIP.ctFinalizationGivenByEnggToPMActualDate) return;
    // New
    // if (!this._dataService.isAdmin) {
      // New end
      if(this.userTaskType == MyTaskType.ADMIN 
        || this.userTaskType == MyTaskType.HEAD_ENGINEERING ){
          //admin or hod, nothing to do now.
      }
      else{
      //filter user
      let elecEnggEmail: string = this._dataService.getElecDesignEngineerEmailId(_subSalesOrder.enggDrawIP.electricalDesignEngineerId);

      if (elecEnggEmail == null || elecEnggEmail == '' || (elecEnggEmail != this._dataService.userId))
       {
        return;
      }
    }
    let _refDate: Date = _subSalesOrder.enggDrawIP.ctFinalizationGivenByEnggToPMPlannedDate;
    if (_refDate) {
      
      this.processThisTask(this._taskList[11].taskId, this._taskList[11].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractSplMatFinalizationGivenByEnggToPMPlannedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 12;
    this.createListItem(_tskIndx);
    if (!_subSalesOrder.enggDrawIP.isSplMatPapplicable) return;
    // New
    // if (!this._dataService.isAdmin) {
      // New end
      if(this.userTaskType == MyTaskType.ADMIN 
        || this.userTaskType == MyTaskType.HEAD_ENGINEERING ){
          //admin or hod, nothing to do now.
      }
      else{
      //filter user
      let elecEnggEmail: string = this._dataService.getElecDesignEngineerEmailId(_subSalesOrder.enggDrawIP.electricalDesignEngineerId);

      if (elecEnggEmail == null || elecEnggEmail == '' || (elecEnggEmail != this._dataService.userId))
       {
        return;
      }
    }
    if (_subSalesOrder.enggDrawIP.splMatActualDate) return;
    let _refDate: Date = _subSalesOrder.enggDrawIP.splMatPlannedDate;
    if (_refDate) {
      // let _taskId: string = "013";
      // let _taskName: string = "Special Material Price Finalization Engg to PM";
      this.processThisTask(this._taskList[12].taskId, this._taskList[12].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractEnggLongLeadRelasePlannedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 13;
    this.createListItem(_tskIndx);
    if (!_subSalesOrder.enggProcureIP.isLongLeadApplicable) return;
    // New
    // if (!this._dataService.isAdmin) {
      // New end
      if(this.userTaskType == MyTaskType.ADMIN 
        || this.userTaskType == MyTaskType.HEAD_ENGINEERING ){
          //admin or hod, nothing to do now.
      }
      else{
      //filter user
      let elecEnggEmail: string = this._dataService.getElecDesignEngineerEmailId(_subSalesOrder.enggDrawIP.electricalDesignEngineerId);

      if (elecEnggEmail == null || elecEnggEmail == '' || (elecEnggEmail != this._dataService.userId))
       {
        return;
      }
    }
    if (_subSalesOrder.enggProcureIP.actualLongLeadReleaseDate) return;
    let _refDate: Date = _subSalesOrder.enggProcureIP.plannedLongLeadReleaseDate;
    if (_refDate) {
      // let _taskId: string = "014";
      // let _taskName: string = "Engineering Long Lead Release ";
      this.processThisTask(this._taskList[13].taskId, this._taskList[13].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractEnggPlannedC40(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 14;
    this.createListItem(_tskIndx);
    if (_subSalesOrder.enggProcureIP.actualC40Date) return;
    // New
    // if (!this._dataService.isAdmin) {
      // New end
      if(this.userTaskType == MyTaskType.ADMIN 
        || this.userTaskType == MyTaskType.HEAD_ENGINEERING ){
          //admin or hod, nothing to do now.
      }
      else{
      //filter user
      let elecEnggEmail: string = this._dataService.getElecDesignEngineerEmailId(_subSalesOrder.enggDrawIP.electricalDesignEngineerId);

      if (elecEnggEmail == null || elecEnggEmail == '' || (elecEnggEmail != this._dataService.userId))
       {
        return;
      }
    }
    let _refDate: Date = _subSalesOrder.enggProcureIP.plannedC40Date;
    if (_refDate) {
      // let _taskId: string = "015";
      // let _taskName: string = "Engineering C40 ";
      this.processThisTask(this._taskList[14].taskId, this._taskList[14].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractEnggPlannedC50(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 15;
    this.createListItem(_tskIndx);
    if (_subSalesOrder.enggProcureIP.actualC50Date) return;
    // New
    // if (!this._dataService.isAdmin) {
      // New end
      if(this.userTaskType == MyTaskType.ADMIN 
        || this.userTaskType == MyTaskType.HEAD_ENGINEERING ){
          //admin or hod, nothing to do now.
      }
      else{
      //filter user
      let mechEnggEmail: string = this._dataService.getMechDesignEngineerEmail(_subSalesOrder.enggDrawIP.mechanicalDesignEngineerId);

      if(mechEnggEmail == null || mechEnggEmail == '' || (mechEnggEmail != this._dataService.userId))
       {
        return;
      }
    }
    let _refDate: Date = _subSalesOrder.enggProcureIP.plannedC50Date;
    if (_refDate) {
      // let _taskId: string = "016";
      // let _taskName: string = "Engineering C50 ";
      this.processThisTask(this._taskList[15].taskId, this._taskList[15].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractEnggPlannedC60(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 16;
    this.createListItem(_tskIndx);
    if (_subSalesOrder.enggProcureIP.actualC60Date) return;
    // New
    // if (!this._dataService.isAdmin) {
    // New end
      if(this.userTaskType == MyTaskType.ADMIN 
        || this.userTaskType == MyTaskType.HEAD_ENGINEERING ){
          //admin or hod, nothing to do now.
      }
      else{
      //filter user
      let elecEnggEmail: string = this._dataService.getElecDesignEngineerEmailId(_subSalesOrder.enggDrawIP.electricalDesignEngineerId);

      if (elecEnggEmail == null || elecEnggEmail == '' || (elecEnggEmail != this._dataService.userId))
       {
        return;
      }
    }
    let _refDate: Date = _subSalesOrder.enggProcureIP.plannedC60Date;
    if (_refDate) {
      // let _taskId: string = "017";
      // let _taskName: string = "Engineering C60 ";
      this.processThisTask(this._taskList[16].taskId, this._taskList[16].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractPurchasePOImportBreakerPOReleasePlannedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 17;
    this.createListItem(_tskIndx);
    if (!_subSalesOrder.enggProcureIP.isLongLeadApplicable) return;
    // New
    // if (!this._dataService.isAdmin) {
    //   //filter user group
    //   if(this._dataService.userType != UserType.PURCHASE){
    //     return;
    //   }
    // }
    // New end
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.PURCHASE_PO
      || this.userTaskType == MyTaskType.HEAD_PURCHASE_PO ){
        //admin or hod, nothing to do now.
    }
    else{
      return
    }
    if (_subSalesOrder.purchasePOIP.importedBreakerPOReleasedActualDate) return;
    let _refDate: Date = _subSalesOrder.purchasePOIP.importedBreakerPOReleasedPlannedDate;
    if (_refDate) {
      // let _taskId: string = "018";
      // let _taskName: string = "Imported Breaker PO Release ";
      this.processThisTask(this._taskList[17].taskId, this._taskList[17].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractPurchasePOImportVSCPOReleasePlannedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 18;
    this.createListItem(_tskIndx);
    if (!_subSalesOrder.enggProcureIP.isLongLeadApplicable) return;
    // New
    // if (!this._dataService.isAdmin) {
    //   //filter user group
    //   if(this._dataService.userType != UserType.PURCHASE){
    //     return;
    //   }
    // }
    // New end
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.PURCHASE_PO
      || this.userTaskType == MyTaskType.HEAD_PURCHASE_PO ){
        //admin or hod, nothing to do now.
    }
    else{
      return
    }
    if (_subSalesOrder.purchasePOIP.importedVSCPOReleasedActualDate) return;
    let _refDate: Date = _subSalesOrder.purchasePOIP.importedVSCPOReleasedPlannedDate;
    if (_refDate) {
      // let _taskId: string = "019";
      // let _taskName: string = "Imported VSC PO Release ";
      this.processThisTask(this._taskList[18].taskId, this._taskList[18].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractPurchasePOGERelayPOReleasePlannedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 19;
    this.createListItem(_tskIndx);
    if (!_subSalesOrder.pmTechSubSalesOrder.isSpecialRelyApplicale) return;
    // New
    // if (!this._dataService.isAdmin) {
    //   //filter user group
    //   if(this._dataService.userType != UserType.PURCHASE){
    //     return;
    //   }
    // }
    // New end
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.PURCHASE_PO
      || this.userTaskType == MyTaskType.HEAD_PURCHASE_PO ){
        //admin or hod, nothing to do now.
    }
    else{
      return
    }
    if (_subSalesOrder.purchasePOIP.geRelayPOReleaseActualDate) return;
    let _refDate: Date = _subSalesOrder.purchasePOIP.geRelayPOReleasePlannedDate;
    if (_refDate) {
      // let _taskId: string = "020";
      // let _taskName: string = "Special Relay PO Release ";
      this.processThisTask(this._taskList[19].taskId, this._taskList[19].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractPurchasePOCTPTPOReleasePlannedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 20;
    this.createListItem(_tskIndx);
    if (_subSalesOrder.purchasePOIP.ctPTPOReleasedActualDate) return;
    // New
    // if (!this._dataService.isAdmin) {
    //   //filter user group
    //   if(this._dataService.userType != UserType.PURCHASE){
    //     return;
    //   }
    // }
    // New end
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.PURCHASE_PO
      || this.userTaskType == MyTaskType.HEAD_PURCHASE_PO ){
        //admin or hod, nothing to do now.
    }
    else{
      return
    }
    let _refDate: Date = _subSalesOrder.purchasePOIP.ctPTPOReleasedPlannedDate;
    if (_refDate) {
      // let _taskId: string = "021";
      // let _taskName: string = "CT/PT PO Release ";
      this.processThisTask(this._taskList[20].taskId, this._taskList[20].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractPurchasePORelayPOReleasePlannedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 21;
    this.createListItem(_tskIndx);
    if (_subSalesOrder.purchasePOIP.relayPOReleasedActualDate) return;
    // New
    // if (!this._dataService.isAdmin) {
    //   //filter user group
    //   if(this._dataService.userType != UserType.PURCHASE){
    //     return;
    //   }
    // }
    // New end
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.PURCHASE_PO
      || this.userTaskType == MyTaskType.HEAD_PURCHASE_PO ){
        //admin or hod, nothing to do now.
    }
    else{
      return
    }
    let _refDate: Date = _subSalesOrder.purchasePOIP.relayPOReleasedPlannedDate;
    if (_refDate) {
      // let _taskId: string = "022";
      // let _taskName: string = "Relay PO Release ";
      this.processThisTask(this._taskList[21].taskId, this._taskList[21].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractPurchasePOBreakerPOReleasePlannedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 22;
    this.createListItem(_tskIndx);
    if (_subSalesOrder.purchasePOIP.breakerPOReleaseActualDate) return;
    // New
    // if (!this._dataService.isAdmin) {
    //   //filter user group
    //   if(this._dataService.userType != UserType.PURCHASE){
    //     return;
    //   }
    // }
    // New end
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.PURCHASE_PO
      || this.userTaskType == MyTaskType.HEAD_PURCHASE_PO ){
        //admin or hod, nothing to do now.
    }
    else{
      return
    }
    let _refDate: Date = _subSalesOrder.purchasePOIP.breakerPOReleasePlannedDate;
    if (_refDate) {
      // let _taskId: string = "023";
      // let _taskName: string = "Breaker PO Release ";
      this.processThisTask(this._taskList[22].taskId, this._taskList[22].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractPurchasePOSAPOReleasePlannedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 23;
    this.createListItem(_tskIndx);
    if (_subSalesOrder.purchasePOIP.saPOReleasedActualDate) return;
    // New
    // if (!this._dataService.isAdmin) {
    //   //filter user group
    //   if(this._dataService.userType != UserType.PURCHASE){
    //     return;
    //   }
    // }
    // New end
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.PURCHASE_PO
      || this.userTaskType == MyTaskType.HEAD_PURCHASE_PO ){
        //admin or hod, nothing to do now.
    }
    else{
      return
    }
    let _refDate: Date = _subSalesOrder.purchasePOIP.saPOReleasedPlannedDate;
    if (_refDate) {
      // let _taskId: string = "024";
      // let _taskName: string = "SA PO Release";
      this.processThisTask(this._taskList[23].taskId, this._taskList[23].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractPurchasePOMeteringBoxPOReleasePlannedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 24;
    this.createListItem(_tskIndx);
    if (_subSalesOrder.purchasePOIP.meteringBoxPOReleaseActualDate) return;
    // New
    // if (!this._dataService.isAdmin) {
    //   //filter user group
    //   if(this._dataService.userType != UserType.PURCHASE){
    //     return;
    //   }
    // }
    // New end
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.PURCHASE_PO
      || this.userTaskType == MyTaskType.HEAD_PURCHASE_PO ){
        //admin or hod, nothing to do now.
    }
    else{
      return
    }
    let _refDate: Date = _subSalesOrder.purchasePOIP.meteringBoxPOReleasePlannedDate;
    if (_refDate) {
      // let _taskId: string = "025";
      // let _taskName: string = "Metering PO Release";
      this.processThisTask(this._taskList[24].taskId, this._taskList[24].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractPlanningPickListIssueToStoresRequestedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 25;
    this.createListItem(_tskIndx);
    if (_subSalesOrder.planningIP.actualPickListIssueToStoreDate) return;
    // New
    // if (!this._dataService.isAdmin) {
    //   //filter user group
    //   if(this._dataService.userType != UserType.PLANNING && this._dataService.userType != UserType.PLANNING_PRODUCTION ){
    //     return;
    //   }
    // }
    // New end
    if (this.userTaskType == MyTaskType.ADMIN
      || this.userTaskType == MyTaskType.PLANNING
      || this.userTaskType == MyTaskType.PLANNING_PRODUCTION
      || this.userTaskType == MyTaskType.HEAD_PLANNING) {
      //admin or hod, nothing to do now.
    }
    else {
      return
    }
    let _refDate: Date = _subSalesOrder.planningIP.requestedPickListIssueToStoreDate;
    if (_refDate) {
      // let _taskId: string = "026";
      // let _taskName: string = "PickList Issue to Stores Requested";
      this.processThisTask(this._taskList[25].taskId, this._taskList[25].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractPurchaseMatRcptImpBreakerRequestedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 26;
    this.createListItem(_tskIndx);
    if (!_subSalesOrder.enggProcureIP.isLongLeadApplicable) return;
    // New
    // if (!this._dataService.isAdmin) {
    //   //filter user group
    //   if(this._dataService.userType != UserType.PURCHASE){
    //     return;
    //   }
    // }
    // New end
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.PURCHASE_PO
      || this.userTaskType == MyTaskType.HEAD_PURCHASE_PO ){
        //admin or hod, nothing to do now.
    }
    else{
      return
    }
    if (_subSalesOrder.purchaseMatReceipt.importedBreakerActualReceiptDate) return;
    let _refDate: Date = _subSalesOrder.purchaseMatReceipt.importedBreakerRequestedReceiptDate;
    if (_refDate) {
      // let _taskId: string = "027";
      // let _taskName: string = "Imported Breaker Requested";
      this.processThisTask(this._taskList[26].taskId, this._taskList[26].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractPurchaseMatRcptImpVSCRequestedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 27;
    this.createListItem(_tskIndx);
    if (!_subSalesOrder.enggProcureIP.isLongLeadApplicable) return;
    // New
    // if (!this._dataService.isAdmin) {
    //   //filter user group
    //   if(this._dataService.userType != UserType.PURCHASE){
    //     return;
    //   }
    // }
    // New end
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.PURCHASE_PO
      || this.userTaskType == MyTaskType.HEAD_PURCHASE_PO ){
        //admin or hod, nothing to do now.
    }
    else{
      return
    }
    if (_subSalesOrder.purchaseMatReceipt.importedVSCActualReceiptDate) return;
    let _refDate: Date = _subSalesOrder.purchaseMatReceipt.importedVSCRequestedReceiptDate;
    if (_refDate) {
      // let _taskId: string = "028";
      // let _taskName: string = "Imported VSC Requested";
      this.processThisTask(this._taskList[27].taskId, this._taskList[27].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractPurchaseMatRcptGERelayRequestedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 28;
    this.createListItem(_tskIndx);
    if (!_subSalesOrder.pmTechSubSalesOrder.isSpecialRelyApplicale) return;
    // New
    // if (!this._dataService.isAdmin) {
    //   //filter user group
    //   if(this._dataService.userType != UserType.PURCHASE){
    //     return;
    //   }
    // }
    // New end
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.PURCHASE_PO
      || this.userTaskType == MyTaskType.HEAD_PURCHASE_PO ){
        //admin or hod, nothing to do now.
    }
    else{
      return
    }
    if (_subSalesOrder.purchaseMatReceipt.geRelayActualReceiptDate) return;
    let _refDate: Date = _subSalesOrder.purchaseMatReceipt.geRelayRequestedReceiptDate;
    if (_refDate) {
      // let _taskId: string = "029";
      // let _taskName: string = "Special Relay Requested";
      this.processThisTask(this._taskList[28].taskId, this._taskList[28].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractPurchaseMaCTPTRequestedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 29;
    this.createListItem(_tskIndx);
    if (_subSalesOrder.purchaseMatReceipt.ctPTActualReceiptDate) return;
    // New
    // if (!this._dataService.isAdmin) {
    //   //filter user group
    //   if(this._dataService.userType != UserType.PURCHASE){
    //     return;
    //   }
    // }
    // New end
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.PURCHASE_PO
      || this.userTaskType == MyTaskType.HEAD_PURCHASE_PO ){
        //admin or hod, nothing to do now.
    }
    else{
      return
    }
    let _refDate: Date = _subSalesOrder.purchaseMatReceipt.ctPTRequestedReceiptDate;
    if (_refDate) {
      // let _taskId: string = "030";
      // let _taskName: string = "CT/PT Requested";
      this.processThisTask(this._taskList[29].taskId, this._taskList[29].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractPurchaseMaRelayRequestedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 30;
    this.createListItem(_tskIndx);
    if (_subSalesOrder.purchaseMatReceipt.relayActualReceiptDate) return;
    // New
    // if (!this._dataService.isAdmin) {
    //   //filter user group
    //   if(this._dataService.userType != UserType.PURCHASE){
    //     return;
    //   }
    // }
    // New end
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.PURCHASE_PO
      || this.userTaskType == MyTaskType.HEAD_PURCHASE_PO ){
        //admin or hod, nothing to do now.
    }
    else{
      return
    }
    let _refDate: Date = _subSalesOrder.purchaseMatReceipt.relayRequestedReceiptDate;
    if (_refDate) {
      // let _taskId: string = "031";
      // let _taskName: string = "Relay Requested";
      this.processThisTask(this._taskList[30].taskId, this._taskList[30].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractPurchaseMaBreakerRequestedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 31;
    this.createListItem(_tskIndx);
    if (_subSalesOrder.purchaseMatReceipt.breakerActualReceiptDate) return;
    // New
    // if (!this._dataService.isAdmin) {
    //   //filter user group
    //   if(this._dataService.userType != UserType.PURCHASE){
    //     return;
    //   }
    // }
    // New end
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.PURCHASE_PO
      || this.userTaskType == MyTaskType.HEAD_PURCHASE_PO ){
        //admin or hod, nothing to do now.
    }
    else{
      return
    }
    let _refDate: Date = _subSalesOrder.purchaseMatReceipt.breakerRequestedReceiptDate;
    if (_refDate) {
      // let _taskId: string = "032";
      // let _taskName: string = "Breaker Requested";
      this.processThisTask(this._taskList[31].taskId, this._taskList[31].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractPurchaseMaJumperRequestedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 32;
    this.createListItem(_tskIndx);
    if (_subSalesOrder.purchaseMatReceipt.jumperActualReceiptDate) return;
    // New
    // if (!this._dataService.isAdmin) {
    //   //filter user group
    //   if(this._dataService.userType != UserType.PURCHASE){
    //     return;
    //   }
    // }
    // New end
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.PURCHASE_PO
      || this.userTaskType == MyTaskType.HEAD_PURCHASE_PO ){
        //admin or hod, nothing to do now.
    }
    else{
      return
    }
    let _refDate: Date = _subSalesOrder.purchaseMatReceipt.jumperRequestedReceiptDate;
    if (_refDate) {
      // let _taskId: string = "033";
      // let _taskName: string = "Jumper Requested";
      this.processThisTask(this._taskList[32].taskId, this._taskList[32].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractPurchaseMaMeterBoxRequestedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 33;
    this.createListItem(_tskIndx);
    if (_subSalesOrder.purchaseMatReceipt.meteringBoxActualReceiptDate) return;
    // New
    // if (!this._dataService.isAdmin) {
    //   //filter user group
    //   if(this._dataService.userType != UserType.PURCHASE){
    //     return;
    //   }
    // }
    // New end
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.PURCHASE_PO
      || this.userTaskType == MyTaskType.HEAD_PURCHASE_PO ){
        //admin or hod, nothing to do now.
    }
    else{
      return
    }
    let _refDate: Date = _subSalesOrder.purchaseMatReceipt.meteringBoxRequestedReceiptDate;
    if (_refDate) {
      // let _taskId: string = "034";
      // let _taskName: string = "Metering Box Requested";
      this.processThisTask(this._taskList[33].taskId, this._taskList[33].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractPurchaseMatSARequestedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 34;
    this.createListItem(_tskIndx);
    if (_subSalesOrder.purchaseMatReceipt.saActualReceiptDate) return;
    // New
    // if (!this._dataService.isAdmin) {
    //   //filter user group
    //   if(this._dataService.userType != UserType.PURCHASE){
    //     return;
    //   }
    // }
    // New end
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.PURCHASE_PO
      || this.userTaskType == MyTaskType.HEAD_PURCHASE_PO ){
        //admin or hod, nothing to do now.
    }
    else{
      return
    }
    let _refDate: Date = _subSalesOrder.purchaseMatReceipt.saRequestedReceiptDate;
    if (_refDate) {
      // let _taskId: string = "035";
      // let _taskName: string = "SA Requested";
      this.processThisTask(this._taskList[34].taskId, this._taskList[34].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractPurchaseMatBoughtoutFabRequestedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 35;
    this.createListItem(_tskIndx);
    if (_subSalesOrder.purchaseMatReceipt.broughtoutFabricationActualReceiptDate) return;
    // New
    // if (!this._dataService.isAdmin) {
    //   //filter user group
    //   if(this._dataService.userType != UserType.PURCHASE){
    //     return;
    //   }
    // }
    // New end
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.PURCHASE_PO
      || this.userTaskType == MyTaskType.HEAD_PURCHASE_PO ){
        //admin or hod, nothing to do now.
    }
    else{
      return
    }
    let _refDate: Date = _subSalesOrder.purchaseMatReceipt.broughtoutFabricationRequestedReceiptDate;
    if (_refDate) {
      // let _taskId: string = "036";
      // let _taskName: string = "Broughtout Fabrication";
      this.processThisTask(this._taskList[35].taskId, this._taskList[35].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractPurchaseMatInHouseFabRequestedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 36;
    this.createListItem(_tskIndx);
    if (_subSalesOrder.purchaseMatReceipt.inHouseFabricationActualReceiptDate) return;
    // New
    // if (!this._dataService.isAdmin) {
    //   //filter user group
    //   if(this._dataService.userType != UserType.PURCHASE){
    //     return;
    //   }
    // }
    // New end
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.PURCHASE_PO
      || this.userTaskType == MyTaskType.HEAD_PURCHASE_PO ){
        //admin or hod, nothing to do now.
    }
    else{
      return
    }
    let _refDate: Date = _subSalesOrder.purchaseMatReceipt.inHouseFabricationRequestedReceiptDate;
    if (_refDate) {
      // let _taskId: string = "037";
      // let _taskName: string = "InHouse Fabrication";
      this.processThisTask(this._taskList[36].taskId, this._taskList[36].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractStoresMatIssuetoLinePlannedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 37;
    this.createListItem(_tskIndx);
    if (_subSalesOrder.storeIP.materialIssueToLineActualDate) return;
    // New
    // if (!this._dataService.isAdmin) {
    //   //filter user group
    //   if(this._dataService.userType != UserType.STORES){
    //     return;
    //   }
    // }
    // New end
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.STORES
      || this.userTaskType == MyTaskType.HEAD_STORES){
        //admin or hod, nothing to do now.
    }
    else{
      return
    }
    let _refDate: Date = _subSalesOrder.storeIP.materialIssueToLineRequestLineLodingDate;
    if (_refDate) {
      // let _taskId: string = "038";
      // let _taskName: string = "Material Issue to Line ";
      this.processThisTask(this._taskList[37].taskId, this._taskList[37].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractStoresMatIssuetoDispatchPlannedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 38;
    this.createListItem(_tskIndx);
    if (_subSalesOrder.storeIP.looseMaterialIssueToDispatchActualDate) return;
    // New
    // if (!this._dataService.isAdmin) {
    //   //filter user group
    //   if(this._dataService.userType != UserType.STORES){
    //     return;
    //   }
    // }
    // New end
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.STORES
      || this.userTaskType == MyTaskType.HEAD_STORES){
        //admin or hod, nothing to do now.
    }
    else{
      return
    }
    let _refDate: Date = _subSalesOrder.storeIP.looseMaterialIssueToDispatchRequestDate;
    if (_refDate) {
      // let _taskId: string = "039";
      // let _taskName: string = "Material Issue to Dispatch";
      this.processThisTask(this._taskList[38].taskId, this._taskList[38].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractProductionMechStickerPlannedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 39;
    this.createListItem(_tskIndx);
    if (_subSalesOrder.productionIP.mechanicalStickerActualDate) return;
    // New
    // if (!this._dataService.isAdmin) {
    //   //filter user group
    //   if(this._dataService.userType != UserType.PRODUCTION && this._dataService.userType != UserType.PLANNING_PRODUCTION ){
    //     return;
    //   }
    // }
    // New end
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.PRODUCTION
      || this.userTaskType == MyTaskType.HEAD_PRODUCTION
      || this.userTaskType == MyTaskType.PLANNING_PRODUCTION){
        //admin or hod, nothing to do now.
    }
    else{
      return
    }
    let _refDate: Date = _subSalesOrder.productionIP.mechanicalStickerRequestedDate;
    if (_refDate) {
      // let _taskId: string = "040";
      // let _taskName: string = "Mechanical Sticker";
      this.processThisTask(this._taskList[39].taskId, this._taskList[39].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractQualityMechElectTestingRequestedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 40;
    this.createListItem(_tskIndx);
    if (_subSalesOrder.qualityIP.mechanicalElectricalTestingActualDate) return;
    // New
    // if (!this._dataService.isAdmin) {
    //   //filter user group
    //   if(this._dataService.userType != UserType.TESTING){
    //     return;
    //   }
    // }
    // New end
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.TESTING
      || this.userTaskType == MyTaskType.HEAD_TESTING){
        //admin or hod, nothing to do now.
    }
    else{
      return
    }
    let _refDate: Date = _subSalesOrder.qualityIP.mechanicalElectricalTestingRequestedDate;
    if (_refDate) {
      // let _taskId: string = "041";
      // let _taskName: string = "Mechanical/Electrical Testing";
      this.processThisTask(this._taskList[40].taskId, this._taskList[40].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractQualityFATRequestedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 41;
    this.createListItem(_tskIndx);
    if (_subSalesOrder.qualityIP.fatActualDate) return;
    // New
    // if (!this._dataService.isAdmin) {
    //   //filter user group
    //   if(this._dataService.userType != UserType.TESTING){
    //     return;
    //   }
    // }
    // New end
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.TESTING
      || this.userTaskType == MyTaskType.HEAD_TESTING){
        //admin or hod, nothing to do now.
    }
    else{
      return
    }
    let _refDate: Date = _subSalesOrder.qualityIP.fatRequestedDate;
    if (_refDate) {
      // let _taskId: string = "042";
      // let _taskName: string = "FAT Requested Date";
      this.processThisTask(this._taskList[41].taskId, this._taskList[41].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractQualityGreenStickerRequestedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 42;
    this.createListItem(_tskIndx);
    if (_subSalesOrder.qualityIP.greenStickerActualDate) return;
    // New
    // if (!this._dataService.isAdmin) {
    //   //filter user group
    //   if(this._dataService.userType != UserType.TESTING){
    //     return;
    //   }
    // }
    // New end
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.TESTING
      || this.userTaskType == MyTaskType.HEAD_TESTING){
        //admin or hod, nothing to do now.
    }
    else{
      return
    }
    let _refDate: Date = _subSalesOrder.qualityIP.greenStickerRequestedDate;
    if (_refDate) {
      // let _taskId: string = "043";
      // let _taskName: string = "Green Sticker Requested Date";
      this.processThisTask(this._taskList[42].taskId, this._taskList[42].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }
  extractLogisticDispatchRequestedDate(_saleOrdr: SalesOrder, _subSalesOrder: SubSalesOrder) {
    let _tskIndx:number = 43;
    this.createListItem(_tskIndx);
    //Logic change added, so that if spares is applicable and spares date is available, 
    //or else lastDelivery actual date is checked
    if(_subSalesOrder.logisticIP.isSparesApplicability == true && _subSalesOrder.logisticIP.sparesActualDispatchDate){
      return;
    }
    if (_subSalesOrder.logisticIP.lastDeliveryActualDate) return;
    //if (_subSalesOrder.logisticIP.sparesActualDispatchDate) return;
    // New
    // if (!this._dataService.isAdmin) {
    //   //filter user group
    //   if(this._dataService.userType != UserType.LOGISTICS){
    //     return;
    //   }
    // }
    // New end
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.LOGISTICS
      || this.userTaskType == MyTaskType.HEAD_LOGISTICS){
        //admin or hod, nothing to do now.
    }
    else{
      return
    }
    let _refDate: Date = _subSalesOrder.logisticIP.dispatchFromPlantRequestDate;
    if (_refDate) {
      // let _taskId: string = "044";
      // let _taskName: string = "Dispatch Requested Date";
      this.processThisTask(this._taskList[43].taskId, this._taskList[43].taskName, _refDate, _saleOrdr, _subSalesOrder);
    }
  }







  initGenTaskObj(_taskId: string, _taskName: string, _jobStatus: MyTaskJobStatus) {
    let _headRow: GenTaskHeadRow;
    switch (_taskId) {
      case "001":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", "", TaskCellType.SALE_ORDER_NO),
          new GenTaskHeadCell("Customer Name", "", TaskCellType.CUSTOMER_NAME),
          new GenTaskHeadCell("Marketing Engineer", "", TaskCellType.MARKETING_ENGINEER)
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "002":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
          new GenTaskHeadCell("Marketing Engineer", "")
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "003":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
          new GenTaskHeadCell("Project Engineer", ""),
          new GenTaskHeadCell("Electrical Design Engineer", "")

        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "004":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
          new GenTaskHeadCell("Project Engineer", ""),
          new GenTaskHeadCell("Mechanical Design Engineer", "")

        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "005":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
          new GenTaskHeadCell("Project Engineer", ""),
          new GenTaskHeadCell("Electrical Design Engineer", "")

        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "006":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
          new GenTaskHeadCell("Project Engineer", ""),
          new GenTaskHeadCell("Electrical Design Engineer", "")

        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "007":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
          new GenTaskHeadCell("Project Engineer", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "008":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
          new GenTaskHeadCell("Project Engineer", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "009":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
          new GenTaskHeadCell("Project Engineer", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "010":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "011":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "012":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
          new GenTaskHeadCell("Electrical Design Engineer", ""),

        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "013":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
          new GenTaskHeadCell("Electrical Design Engineer", ""),

        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "014":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
          new GenTaskHeadCell("Electrical Design Engineer", ""),

        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "015":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
          new GenTaskHeadCell("Electrical Design Engineer", ""),

        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "016":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
          new GenTaskHeadCell("Mechanical Design Engineer", ""),

        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "017":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
          new GenTaskHeadCell("Electrical Design Engineer", ""),

        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "018":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "019":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "020":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "021":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "022":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "023":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "024":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "025":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "026":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "027":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "028":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "029":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "030":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "031":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "032":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "033":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "034":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "035":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "036":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "037":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "038":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "039":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "040":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "041":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "042":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "043":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);
      case "044":
        _headRow = new GenTaskHeadRow([
          new GenTaskHeadCell("Sale Order", ""),
          new GenTaskHeadCell("Sub Order", ""),
          new GenTaskHeadCell("Customer Name", ""),
        ]);
        if(_jobStatus == MyTaskJobStatus.DELAYED ||_jobStatus == MyTaskJobStatus.UPCOMING){
          _headRow.headCells.push(new GenTaskHeadCell("", 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-head-cls" : "upcoming-head-cls")
          ,TaskCellType.DELAY_INDICATOR));
        }
        return new GenTaskData(_taskId, _taskName, _headRow, []);


        break;
    }
    return null;
  }
  initGenTaskRow(_taskId: string, _saleOrdr: SalesOrder, _subOrder: SubSalesOrder, _jobStatus: MyTaskJobStatus, _daysDiff:number, _titleInfo:string, _downAddInfo:string) {
    let _tmpGentaskRow:GenTaskDataRow;
    switch (_taskId) {
      case "001":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId, "param1":"marketing", "param2":"0" }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
            new GenTaskDataCell(this._dataService.getMarketingEngineerName(_saleOrdr.marketingIP.marketingEngineerId), TaskCellType.MARKETING_ENGINEER, { "mktgid": _saleOrdr.marketingIP.marketingEngineerId })
          ],
          _titleInfo, _downAddInfo
        );

        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "002":
        _tmpGentaskRow= new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId, "param1":"marketing", "param2":"0" }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
            new GenTaskDataCell(this._dataService.getMarketingEngineerName(_saleOrdr.marketingIP.marketingEngineerId), TaskCellType.MARKETING_ENGINEER, { "mktgid": _saleOrdr.marketingIP.marketingEngineerId })
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "003":
        _tmpGentaskRow= new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId, "param1":"enggdraw", "param2": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
            new GenTaskDataCell(this._dataService.getProjectEngineerName(_saleOrdr.pmCommercial.projectEngineerId), TaskCellType.PROJECT_ENGINEER, { "PrjEngid": _saleOrdr.pmCommercial.projectEngineerId }),
            new GenTaskDataCell(this._dataService.getElecDesignEngineerName(_subOrder.enggDrawIP.electricalDesignEngineerId), TaskCellType.MARKETING_ENGINEER, { "electEngid": _subOrder.enggDrawIP.electricalDesignEngineerId })
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "004":
        _tmpGentaskRow= new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId,  "param1":"enggdraw", "param2": _subOrder.subOrderNoId  }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
            new GenTaskDataCell(this._dataService.getProjectEngineerName(_saleOrdr.pmCommercial.projectEngineerId), TaskCellType.PROJECT_ENGINEER, { "PrjEngid": _saleOrdr.pmCommercial.projectEngineerId }),
            new GenTaskDataCell(this._dataService.getMechDesignEngineerName(_subOrder.enggDrawIP.mechanicalDesignEngineerId), TaskCellType.MARKETING_ENGINEER, { "mechEngid": _subOrder.enggDrawIP.mechanicalDesignEngineerId })
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "005":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId,  "param1":"enggdraw", "param2": _subOrder.subOrderNoId  }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
            new GenTaskDataCell(this._dataService.getProjectEngineerName(_saleOrdr.pmCommercial.projectEngineerId), TaskCellType.PROJECT_ENGINEER, { "PrjEngid": _saleOrdr.pmCommercial.projectEngineerId }),
            new GenTaskDataCell(this._dataService.getElecDesignEngineerName(_subOrder.enggDrawIP.electricalDesignEngineerId), TaskCellType.MARKETING_ENGINEER, { "electEngid": _subOrder.enggDrawIP.electricalDesignEngineerId })
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "006":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId,  "param1":"enggdraw", "param2": _subOrder.subOrderNoId  }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
            new GenTaskDataCell(this._dataService.getProjectEngineerName(_saleOrdr.pmCommercial.projectEngineerId), TaskCellType.PROJECT_ENGINEER, { "PrjEngid": _saleOrdr.pmCommercial.projectEngineerId }),
            new GenTaskDataCell(this._dataService.getElecDesignEngineerName(_subOrder.enggDrawIP.electricalDesignEngineerId), TaskCellType.MARKETING_ENGINEER, { "electEngid": _subOrder.enggDrawIP.electricalDesignEngineerId })
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "007":
      _tmpGentaskRow= new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId,  "param1":"sso", "param2": _subOrder.subOrderNoId  }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
            // new GenTaskDataCell(_subOrder.pmTechSubSalesOrder.plannedDrawingApprovalDate, TaskCellType.PROJECT_ENGINEER, { "PrjEngid": _saleOrdr.pmCommercial.projectEngineerId }),
            new GenTaskDataCell(this._dataService.getProjectEngineerName(_saleOrdr.pmCommercial.projectEngineerId), TaskCellType.PROJECT_ENGINEER, { "PrjEngid": _saleOrdr.pmCommercial.projectEngineerId }),

          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "008":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId,  "param1":"sso", "param2": _subOrder.subOrderNoId  }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
            new GenTaskDataCell(this._dataService.getProjectEngineerName(_saleOrdr.pmCommercial.projectEngineerId), TaskCellType.PROJECT_ENGINEER, { "PrjEngid": _saleOrdr.pmCommercial.projectEngineerId }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "009":
      _tmpGentaskRow =new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId, "param1":"sso", "param2": _subOrder.subOrderNoId  }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
            // new GenTaskDataCell(_subOrder.pmTechSubSalesOrder.plannedDrawingApprovalDate, TaskCellType.PROJECT_ENGINEER, { "PrjEngid": _saleOrdr.pmCommercial.projectEngineerId }),
            new GenTaskDataCell(this._dataService.getProjectEngineerName(_saleOrdr.pmCommercial.projectEngineerId), TaskCellType.PROJECT_ENGINEER, { "PrjEngid": _saleOrdr.pmCommercial.projectEngineerId }),

          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "010":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId, "param1":"scm", "param2": _subOrder.subOrderNoId   }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),

          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "011":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId, "param1":"scm", "param2": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),

          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "012":
        _tmpGentaskRow = new GenTaskDataRow(

          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, {  "soid": _saleOrdr.salesOrderId, "param1":"enggdraw", "param2": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
            new GenTaskDataCell(this._dataService.getElecDesignEngineerName(_subOrder.enggDrawIP.electricalDesignEngineerId), TaskCellType.CUSTOMER_NAME, { "electEngid": _subOrder.enggDrawIP.electricalDesignEngineerId }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "013":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId,  "param1":"enggdraw", "param2": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
            new GenTaskDataCell(this._dataService.getElecDesignEngineerName(_subOrder.enggDrawIP.electricalDesignEngineerId), TaskCellType.CUSTOMER_NAME, { "electEngid": _subOrder.enggDrawIP.electricalDesignEngineerId }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "014":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId, "param1":"engg", "param2": _subOrder.subOrderNoId  }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
            new GenTaskDataCell(this._dataService.getElecDesignEngineerName(_subOrder.enggDrawIP.electricalDesignEngineerId), TaskCellType.CUSTOMER_NAME, { "electEngid": _subOrder.enggDrawIP.electricalDesignEngineerId }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "015":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId,  "param1":"engg", "param2": _subOrder.subOrderNoId  }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
            new GenTaskDataCell(this._dataService.getElecDesignEngineerName(_subOrder.enggDrawIP.electricalDesignEngineerId), TaskCellType.CUSTOMER_NAME, { "electEngid": _subOrder.enggDrawIP.electricalDesignEngineerId }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "016":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId,  "param1":"engg", "param2": _subOrder.subOrderNoId  }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
            new GenTaskDataCell(this._dataService.getMechDesignEngineerName(_subOrder.enggDrawIP.mechanicalDesignEngineerId), TaskCellType.CUSTOMER_NAME, { "mechEngid": _subOrder.enggDrawIP.mechanicalDesignEngineerId }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "017":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId,  "param1":"engg", "param2": _subOrder.subOrderNoId  }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
            new GenTaskDataCell(this._dataService.getElecDesignEngineerName(_subOrder.enggDrawIP.electricalDesignEngineerId), TaskCellType.CUSTOMER_NAME, { "electEngid": _subOrder.enggDrawIP.electricalDesignEngineerId }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "018":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId, "param1":"purchase", "param2": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "019":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId, "param1":"purchase", "param2": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "020":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId, "param1":"purchase", "param2": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "021":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId, "param1":"purchase", "param2": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "022":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId, "param1":"purchase", "param2": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "023":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId, "param1":"purchase", "param2": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "024":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId, "param1":"purchase", "param2": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "025":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId,"param1":"purchase", "param2": _subOrder.subOrderNoId  }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "026":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId,"param1":"planning", "param2": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "027":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId,"param1":"matreceipt", "param2": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "028":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId,"param1":"matreceipt", "param2": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "029":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId,"param1":"matreceipt", "param2": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "030":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId,"param1":"matreceipt", "param2": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "031":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId,"param1":"matreceipt", "param2": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "032":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId,"param1":"matreceipt", "param2": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "033":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId,"param1":"matreceipt", "param2": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "034":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId,"param1":"matreceipt", "param2": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "035":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId,"param1":"matreceipt", "param2": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "036":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId,"param1":"matreceipt", "param2": _subOrder.subOrderNoId}),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "037":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId,"param1":"matreceipt", "param2": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "038":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId,"param1":"store", "param2": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "039":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId,"param1":"store", "param2": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "040":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId,"param1":"production", "param2": _subOrder.subOrderNoId}),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "041":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId, "param1":"quality", "param2": _subOrder.subOrderNoId  }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "042":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId, "param1":"quality", "param2": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "043":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId, "param1":"quality", "param2": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;
      case "044":
        _tmpGentaskRow = new GenTaskDataRow(
          [
            new GenTaskDataCell(_saleOrdr.marketingIP.salesOrderNo, TaskCellType.SALE_ORDER_NO, { "soid": _saleOrdr.salesOrderId, "param1":"logistic", "param2": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_subOrder.subOrderNoId, TaskCellType.SUB_ORDER, { "sono": _subOrder.subOrderNoId }),
            new GenTaskDataCell(_saleOrdr.marketingIP.customerName, TaskCellType.CUSTOMER_NAME, { "custname": _saleOrdr.marketingIP.customerName }),
          ],
          _titleInfo, _downAddInfo
        );
        if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
          _tmpGentaskRow.cellRows.push(new GenTaskDataCell(_daysDiff, TaskCellType.DELAY_INDICATOR, { "daysDiff": _daysDiff }, 
          ((_jobStatus == MyTaskJobStatus.DELAYED) ? "delay-cls" : "upcoming-cls")
          ));
        }
        return _tmpGentaskRow;






        break;
    }
    return null;
  }




  //generalised Functions
  getGenTaskObj(_jobStatus: MyTaskJobStatus, _taskId: string, _taskName: string) {

    let _genTaskData: GenTaskData;

    if (_jobStatus == MyTaskJobStatus.DELAYED) {
      _genTaskData = this.delayedJobs.find((_obj: GenTaskData) => {
        return _obj.taskId == _taskId;
      });
    }
    else if (_jobStatus == MyTaskJobStatus.RUNNING) {
      _genTaskData = this.runningJobs.find((_obj: GenTaskData) => {
        return _obj.taskId == _taskId;
      });
    }
    else if (_jobStatus == MyTaskJobStatus.UPCOMING) {
      _genTaskData = this.upcomingJobs.find((_obj: GenTaskData) => {
        return _obj.taskId == _taskId;
      });
    }

    if (_genTaskData == null) {
      _genTaskData = this.initGenTaskObj(_taskId, _taskName, _jobStatus);

      if (_genTaskData != null) {
        this.addGenTaskObj(_jobStatus, _genTaskData);
      }
    }
    return _genTaskData;
  }
  addGenTaskObj(_jobStatus: MyTaskJobStatus, _obj: GenTaskData) {

    if (_jobStatus == MyTaskJobStatus.DELAYED) {
      this.delayedJobs.push(_obj);
    }
    else if (_jobStatus == MyTaskJobStatus.RUNNING) {
      this.runningJobs.push(_obj);
    }
    else if (_jobStatus == MyTaskJobStatus.UPCOMING) {
      this.upcomingJobs.push(_obj);
    }
  }
  processThisTask(_taskId: string, _taskName: string, _refDate: Date, _saleOrdr: SalesOrder, _subOrder: SubSalesOrder) {
    let _daysDiff:number = configDefs.getDaysDifference2(_refDate, this.currDate);
    
    if(_daysDiff == null) return;

    let _jobStatus: MyTaskJobStatus = configDefs.compareMyTaskDays(_daysDiff, this.upcomingSelId);

    if (_jobStatus && _jobStatus != MyTaskJobStatus.UNKNOWN) {


      let _genTaskData: GenTaskData = this.getGenTaskObj(_jobStatus, _taskId, _taskName);

      if (_genTaskData == null) {
        console.log('failed to init task with task ID ' + _taskId)
        return;
      }

      let _addInfo:string = '';
      let _downAddInfo:string = '';

      //if(_jobStatus == MyTaskJobStatus.DELAYED || _jobStatus == MyTaskJobStatus.UPCOMING){
      _addInfo = _taskName + "\n" + 
                      ((this._requestedTaskIdList.indexOf(_taskId) < 0) ? "Planned/Revised Date : "  : "Requested Date : ") + 
                      GenService.getDateFormatStr(_refDate,"DD-mmm-YYYY");
        
        _downAddInfo = GenService.getDateFormatStr(_refDate,"DD-mmm-YYYY");

        if(_jobStatus == MyTaskJobStatus.DELAYED){
          _addInfo += "\nDelayed by " + (-1 * _daysDiff) +" days";
        }
        else if(_jobStatus == MyTaskJobStatus.UPCOMING){
          _addInfo += "\nExpected in " + _daysDiff +" days";
        }
      //}
    
      let _dataRow: GenTaskDataRow = this.initGenTaskRow(_taskId, _saleOrdr, _subOrder,_jobStatus,_daysDiff, _addInfo, _downAddInfo);

      if (_dataRow) {
        _genTaskData.taskDisplayDataRows.push(_dataRow);
      }
    }
  }
}

class taskDef{
  constructor(public taskId:string, public taskName){

  }
}